<template>
  <div class="pt-10 pb-5 component-div">
    <b-row>
      <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
        <div class="number-sequence">
          <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
          <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
        </div>
        <span
          class="ml-2 question-tital-name"
          :class="isFieldDisabled ? 'disable-question' : ''"
          v-translate:_formattedBody="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.formattedBody
          }"
          v-html="componentData.formattedBody"
        ></span>
        <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isFieldDisabled ? 'disable-question' : ''" v-if="componentData.isSkippable" v-translate:_optional="{ key: 'label', val: lang, html: 'Optional' }">Optional</span>
        <span v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">Skipped</span>
        <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
          <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
        </div>
        <span v-if="hasFieldError" class="text-danger pl-5 fw-bold">{{ fieldErrorText }}</span>
      </b-col>
    </b-row>

    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <div class="pl-40 pt-10">
        <div v-if="!componentData.verticalScale">
          <div v-if="activityInfo.newLayout && activityInfo.newLayout == true">
            <div class="row">
              <div
                v-translate:_minValueLabel="{
                  key: translationKeyInitial,
                  val: lang,
                  html: componentData.minValueLabel
                }"
                class="col-md-3 pr-10"
              >
                {{ componentData.minValueLabel }}
              </div>
              <div class="col-md-6">
                <ds-slider :ref="'slider_' + componentData.id" :value="getValueForVAS()" direction="horizontal" :width="componentData.restrainLengthValue + 'mm'" class="horizontal-vue-slider" :min="componentData.minValue" :max="componentData.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"> </ds-slider>
                <div class="pt-10 scaleLabels-vas">
                  <span :style="{ 'margin-left': 15 + 'px' }">{{ componentData.minValue }}</span>
                  <span class="pull-right">{{ componentData.maxValue }}</span>
                </div>
              </div>
              <div
                v-translate:_minValueLabel="{
                  key: translationKeyInitial,
                  val: lang,
                  html: componentData.maxValueLabel
                }"
                class="col-md-3"
              >
                {{ componentData.maxValueLabel }}
              </div>
            </div>
          </div>
          <div v-else>
            <div class="scaleLabels-vas">
              <div :style="{ 'margin-left': 15 + 'px' }">
                {{ componentData.minValueLabel }}
              </div>
              <div
                v-translate:_maxValueLabel="{
                  key: translationKeyInitial,
                  val: lang,
                  html: componentData.maxValueLabel
                }"
                class="pull-right"
                :style="{ right: componentData.restrainLengthValue + 'mm' }"
              >
                {{ componentData.maxValueLabel }}
              </div>
            </div>
            <dsSlider :ref="'slider_' + componentData.id" :value="getValueForVAS()" direction="horizontal" :width="componentData.restrainLengthValue + 'mm'" class="horizontal-vue-slider pl-20 pt-20 pb-10 mb-5" :min="componentData.minValue" :max="componentData.maxValue" v-if="!componentData.verticalScale" disabled />
            <div class="scaleLabels-vas">
              <span :style="{ 'margin-left': 15 + 'px' }">
                {{ componentData.minValue }}
              </span>
              <span class="pull-right" :style="{ right: componentData.restrainLengthValue + 'mm' }">
                {{ componentData.maxValue }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="componentData.verticalScale">
          <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ componentData.maxValue }}</span>

          <span
            v-translate:_maxValueLabel="{
              key: translationKeyInitial,
              val: lang,
              html: componentData.maxValueLabel
            }"
            :style="{ 'margin-left': 30 + 'px' }"
            class="scaleLabels"
            >{{ componentData.maxValueLabel }}</span
          >
          <dsSlider :ref="'slider_' + componentData.id" :value="getValueForVAS()" width="5" :height="componentData.restrainLengthValue + 'mm'" direction="vertical" class="vertical-vue-slider pl-20" :min="componentData.minValue" :max="componentData.maxValue" v-if="componentData.verticalScale" disabled />
          <div class="scaleLabels" v-if="componentData.verticalScale">
            <span :style="{ 'margin-left': 30 + 'px' }">{{ componentData.minValue }}</span>
            <span
              v-translate:_minValueLabel="{
                key: translationKeyInitial,
                val: lang,
                html: componentData.minValueLabel
              }"
              :style="{ 'margin-left': 30 + 'px' }"
              >{{ componentData.minValueLabel }}</span
            >
          </div>
        </div>
        <b-col cols="8"></b-col>
      </div>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row class="pl-10" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-col cols="8" class="mt-10 ">
          <div v-if="!componentData.verticalScale">
            <div class="scaleLabels-vas">
              <div
                v-translate:_minValueLabel="{
                  key: translationKeyInitial,
                  val: lang,
                  html: componentData.minValueLabel
                }"
                :style="{ 'margin-left': 15 + 'px' }"
              >
                {{ componentData.minValueLabel }}
              </div>
              <div
                v-translate:_maxValueLabel="{
                  key: translationKeyInitial,
                  val: lang,
                  html: componentData.maxValueLabel
                }"
                class="pull-right"
                :style="{
                  left: componentData.restrainLengthValue + 'mm',
                  width: componentData.restrainLengthValue + 'mm'
                }"
              >
                {{ componentData.maxValueLabel }}
              </div>
            </div>
            <dsSlider
              :ref="'slider_' + componentData.id"
              :value="getValueForVAS()"
              direction="horizontal"
              class="horizontal-vue-slider pl-20 pt-34 pb-10 mb-5"
              :width="this.displayMobileView === true ? componentData.restrainLengthValue + 'px' : componentData.restrainLengthValue + 'mm'"
              :min="componentData.minValue"
              :max="componentData.maxValue"
              v-if="!componentData.verticalScale"
              :disabled="isFieldDisabled"
              @drag-end="onFieldChange"
              :clickable="false"
            />
            <div class="scaleLabels-vas">
              <span :style="{ 'margin-left': 15 + 'px' }">
                {{ componentData.minValue }}
              </span>
              <span
                class="pull-right"
                :style="{
                  left: componentData.restrainLengthValue + 'mm',
                  width: componentData.restrainLengthValue + 'mm'
                }"
              >
                {{ componentData.maxValue }}
              </span>
            </div>
          </div>
          <div v-if="componentData.verticalScale">
            <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ componentData.maxValue }}</span>
            <span
              v-translate:_maxValueLabel="{
                key: translationKeyInitial,
                val: lang,
                html: componentData.maxValueLabel
              }"
              :style="{ 'margin-left': 30 + 'px' }"
              class="scaleLabels"
              >{{ componentData.maxValueLabel }}</span
            >
            <dsSlider :ref="'slider_' + componentData.id" :value="getValueForVAS()" width="5" direction="vertical" class="vertical-vue-slider pl-50 mb-5" :height="componentData.restrainLengthValue + 'mm'" :min="componentData.minValue" :max="componentData.maxValue" v-if="componentData.verticalScale" :disabled="isFieldDisabled" @drag-end="onFieldChange" :clickable="false" />
            <div class="scaleLabels" v-if="componentData.verticalScale">
              <span :style="{ 'margin-left': 30 + 'px' }">{{ componentData.minValue }}</span>
              <span
                v-translate:_minValueLabel="{
                  key: translationKeyInitial,
                  val: lang,
                  html: componentData.minValueLabel
                }"
                :style="{ 'margin-left': 30 + 'px' }"
                >{{ componentData.minValueLabel }}</span
              >
            </div>
          </div>
        </b-col>
        <b-col cols="4"> </b-col>
      </b-row>
      <div :class="isFieldDisabled ? 'disable-question' : ''">
        <span class="activity-form__clear pl-43" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>
        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }" class="fs-12">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            {{ componentData.actualScore || showScore(componentData.skipScore) }}
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div class="answers ml-25">{{ componentData.answer }}</div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-25" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
            class="answers previous-value"
          >
            Previous value
          </div>
          <div>{{ componentData.previousAnswer }}</div>
          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import dsSlider from "@/lib/ds-slider-component";
import * as constant from "../../../constants/config";
import langTranslate from "./lang-translate";

export default {
  name: "activity-form-vas-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      displayMobileView: Boolean
    };
  },
  created() {
    if (constant.SCREENWIDTH > 1200) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  mounted() {
    if (this.componentData) {
      if (this.completeEdit) {
        this.componentData.defaultAnswer = this.componentData.answer;
      } else {
        this.componentData.defaultAnswer = "";
      }
      const $this = this;
      const slider = "slider_" + this.componentData.id;
      setTimeout(() => {
        $this.$refs[slider].refresh();
      }, 5000);
    }
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }
  },
  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    completeEdit: {
      type: Boolean,
      default: false
    }
  },

  components: {
    dsSlider
  },

  watch: {
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.checkForFieldErrors();
      }
    },
    isFieldDisabled(val) {
      if (val === true) {
        this.resetField();
      }
    }
  },

  methods: {
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    resetField() {
      this.componentData.answer = undefined;
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.componentData.defaultAnswer = "";
      this.resetAllErrors();
      this.$emit("getQuestionScores");
    },
    clearAnswer() {
      this.resetField();
      this.$emit("onClearAnswer", this.componentData);
      this.resetAllErrors();
    },
    onFieldChange(event) {
      this.componentData.answer = event.val;
      this.componentData.defaultAnswer = event.val;
      this.checkForFieldErrors();
      this.onAnswerChange();
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
    },
    checkForFieldErrors() {
      let { isSkippable, answer, dataEditChecks } = this.componentData;

      this.resetAllErrors();
      this.componentData.dataChecks = [];

      if (dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "NOT_BLANK" && answer == "") {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `This field is required.`;
              isSkippable = true;
              softDataCheck = true;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
            if (dataEditChecks[k].type == "LESS_THAN" && Number(answer) > dataEditChecks[k].value) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              isSkippable = true;
              this.fieldWarningText = `This field should be less than (${dataEditChecks[k].value}).`;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: "soft",
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
            if (dataEditChecks[k].type == "GREATER_THAN" && Number(answer) < dataEditChecks[k].value) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              isSkippable = true;
              this.fieldWarningText = `This field should be greater than ${dataEditChecks[k].value}.`;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: "soft",
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
          } else {
            if (dataEditChecks[k].type == "NOT_BLANK" && answer == "") {
              this.hasFieldError = true;
              this.hasFieldWarning = false;
              this.fieldErrorText = "This field is required.";
              this.fieldWarningText = "";
              isSkippable = false;

              return false;
            } else if (dataEditChecks[k].type == "LESS_THAN" && Number(answer) > dataEditChecks[k].value) {
              this.hasFieldWarning = false;
              this.hasFieldError = true;
              this.fieldWarningText = "";
              isSkippable = false;
              this.fieldErrorText = `This field should be less than ${dataEditChecks[k].value}.`;
              return false;
            } else if (dataEditChecks[k].type == "GREATER_THAN" && Number(answer) < dataEditChecks[k].value) {
              this.hasFieldWarning = false;
              this.hasFieldError = true;
              this.fieldWarningText = "";
              isSkippable = false;
              this.fieldErrorText = `This field should be greater than ${dataEditChecks[k].value}.`;
              return false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }
      if (!isSkippable && (answer === "" || typeof answer === "undefined")) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
      }
    },
    getValueForVAS() {
      if (this.componentData.answer || this.componentData.answer === 0) {
        return this.componentData.answer;
      }
      return this.componentData.minValue;
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.componentData.computedScore = this.componentData.score;
        this.componentData.actualScore = this.componentData.score;
        this.$emit("onAnswerChange", this.componentData);
      });
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.scaleLabels {
  font-size: 12px;
  color: #666669;
}
.scaleLabels-vas {
  font-size: 12px;
  color: #666669;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.pull-right {
  margin-left: -15px;
  position: absolute;
  top: auto;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
</style>
